import { CONSTANTS, NumberUtils } from '@pk/powerkioskutils';

export class ViewSupplierHistoricalActivity {
	public contractId: string;
	public supplierName: string;
	public contractNum: string;
	public date: Date;
	public status: number;
	public serviceTypeId: string;
	public annualUsage: number;
	public term: number;
	public termVolume: number;
	public agentId: string;
	public agentName: string;
	public dbaName: string;
	public customerId: string;
	public displayStatus: string;
	public annualUsageConverted: number;
	public termVolumeConverted: number;

	constructor(data?: Partial<ViewSupplierHistoricalActivity>) {
		Object.assign(this, data);
		const isElec = this.serviceTypeId === CONSTANTS.serviceTypes.electricity.serviceTypeId;
		const unit = isElec ? 'mwh' : 'dth';
		this.annualUsageConverted = NumberUtils.amountToUnits(this.annualUsage, unit);
		this.termVolumeConverted = NumberUtils.amountToUnits(this.termVolume, unit);
	}
}
